import React from "react";

export default function ClosureAttentionIcon({ iconOnly }: { iconOnly?: boolean }) {
    return (
        <span className={`day-selector-closure-icon${iconOnly ? ' day-selector-closure-icon--mark-only' : ''}`} aria-hidden="true">
            <svg viewBox="0 0 24 24" width="12" height="12" focusable="false">
                {!iconOnly && (
                    <path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10" />
                )}
                <path fill="currentColor" d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7z" />
            </svg>
        </span>
    );
}
